ACC.customercatalog = {
    _autoload: [
        "toggleFilters",
        "loadMoreInMobile",
        "triggerDownload",
        "triggerUpload",
        ["changeForm", $(window).width() > 640]
    ],

    toggleFilters: function () {
        $(".js-more-filters").click(function (e) {
            e.preventDefault();
            $(".wrapper-more-filters").toggleClass("hidden-filters");
        });
    },
    loadMoreInMobile: function () {
        var paginate = 0;
        if ($(window).width() < 640 && $(".page-customer-catalog")[0]) {
            $('.form-attr .btn-save').addClass('hidden');
            loadMoreData(paginate);
            //ACC.customercatalog.updateRefFront();
            $(window).scroll(function () {
                $(".btn-save").addClass('fixed-save-btn')
                //on pagine lorsque l'on a d�fil� toute la hauteur moins une hauteur d'�cran
                if ($(window).scrollTop() >= $(".account-section").height() - 640) {
                    paginate = paginate + 20;
                    loadMoreData(paginate);
                    $(".btn-save").removeClass('fixed-save-btn')
                }
            });
        }

        // run function when user reaches to end of the page
        function loadMoreData(lineNumberOnPage) {
            var reference = $.trim($('#idreference').val()),
                referenceGET = '';

            if (reference != "") {
                referenceGET = "term=" + reference + "&";
            }

            $.ajax({
                url: ACC.config.encodedContextPath + "/my-account/customer-catalog/onlinesCatalog?" + referenceGET + "start=" + lineNumberOnPage,
                type: 'get',
                datatype: 'html',
                beforeSend: function () {
                    $('.loading-scroll').show();
                },
                success: function (res) {
                    if ($(window).width() < 640) {
                        setTimeout(function () {
                            if (res.length == 0) {
                                $('.loading-scroll').hide();
                                return;
                            } else {
                                $('.loading-scroll').hide();
                                $('.form-attr .btn-save').removeClass('hidden');
                                var errorTextMax = $(".js-error-max-char").text();
                                var errorTextUnique = $(".js-error-unique-ref").text();
                                $.each(res.data, function (i, item) {
                                    $('#mobileCustomerCatalog').append(
                                        "<tr class='responsive-table-item'>\
                                            <ycommerce:testId code='orderHistoryItem_orderDetails_link'>\
                                                <td class='responsive-table-cell'>" + item[1] + "</td>\
                                                <td class='responsive-table-cell idRefMobile'>" + item[2] + "</td>\
                                                <td class='responsive-table-cell'>" + item[3] + "</td>\
                                                <td class='responsive-table-cell ref-info editTextMobile'>\
                                                <div class='visible-xs'>" + $(".js-val-ref").text() + "</div>\
                                                <div class='ref-infos'>\
                                                <div class='editContainerMobile'>\
                                                <input type='text' readonly class='edit-ref-input mobile' name='editRef' data-old='" + item[4] + "' value='" + item[4] + "'/>\
                                                <div class='pk-text hidden'>" + item[5] + "</div>\
                                                <div class='ref-errors hidden'>\
                                                <span class='max-char-error ref-error hidden'>" + errorTextMax + "</span>\
                                                <span class='unique-error ref-error hidden'>" + errorTextUnique + "</span>\
                                                </div>\
                                                </div> <div class='icon-edit js-btn-edit-ref-mobile'>\
                                                <img src='/_ui/responsive/theme-amds/images/picto-edit.png' style='vertical-align:text-top;margin-right:10px;width:20px;'>\
                                                </div>\
                                                </div>\
                                                </td>\
                                                <td class='choose-input'>\
                                                    <div class='form-checkbox'>\
                                                        <input type='checkbox' class='check-catalogue js-check-mobile' name='check-catalogue'>\
                                                        <label for='checkboxRef'></label>\
                                                    </div>\
                                                </td>\
                                            </ycommerce:testId>\
                                        </tr>"
                                    );
                                });
                            }

                            ACC.datatables.tableRefInitPaged = res.data;
                            //ACC.customercatalog.updateRefFront();
                        }, 500);

                        $(document).on('click', ".js-btn-edit-ref-mobile:not(.disabled)", function () {
                            let _this = $(this),
                                parent = _this.closest(".ref-infos"),
                                refText = parent.find('.ref-text'),
                                inputElement = parent.find('.edit-ref-input.mobile'),
                                newText = inputElement.val().trim();
                            _this.addClass('hidden');// hide button

                            inputElement.removeAttr('readonly').focus();// copy data and display the input
                            //saveBtn.removeClass('hidden');// display save btn
                        });

                        $(document).on('focusout', '.edit-ref-input.mobile', function (event) {
                            let _this = $(this),
                                editBtn = $('.js-btn-edit-ref-mobile'),
                                container = _this.closest(".responsive-table-item"),
                                inputElementValue = container.find('.edit-ref-input.mobile').val().trim(),
                                productCode = container.find('.idRefMobile').text();

                            if (inputElementValue.length > 35) {
                                _showError(container, _this, 'max-char-error');
                            } else {
                                _hideError(container, _this);
                                editBtn.removeClass('hidden');// hide button
                                // update data if null set the default value otherwise set the new val !
                                _this.data('old', inputElementValue);

                                //check if the ref is already exesting !
                                if (inputElementValue.length > 0) {

                                    let isExistingRef = ACC.datatables._customerCatalogProducts.filter(o => (o.productReference == inputElementValue))

                                    if (isExistingRef.length > 0 && isExistingRef[0].productCode !== productCode) {
                                        _showError(container, _this, refText, 'unique-error')
                                    } else {
                                        _hideError(container, _this);
                                        //recheck before add
                                        let isExistingWithSameRef = ACC.datatables.tableRefUpdated.filter(o => (o.productCode == productCode))
                                        if (isExistingWithSameRef.length === 0) {
                                            let _ = ACC.datatables.tableRefUpdated.filter(o => (o.productCode == productCode || o.productReference == inputElementValue));
                                            if (_.length !== 0) {
                                                _showError(container, _this, refText, 'unique-error')
                                            } else {
                                                ACC.datatables.tableRefUpdated.push({
                                                    productCode: productCode,
                                                    productName: '',
                                                    productReference: inputElementValue
                                                });
                                            }
                                        } else {
                                            //update ref or remove is with same values
                                            const index = ACC.datatables.tableRefUpdated.findIndex(o => o.productCode === productCode);
                                            ACC.datatables.tableRefUpdated[index].productReference = inputElementValue;
                                        }

                                    }
                                } else {
                                    ACC.datatables.tableRefUpdated = ACC.datatables.tableRefUpdated.filter((o) => o.productCode !== productCode);
                                }


                            }
                            if (inputElementValue.length !== 0 && ACC.datatables.tableRefUpdated.length > 0) {
                                $(".status-saving .text-status").addClass("hidden");
                                $(".status-saving .text-status.not-saving").removeClass("hidden");
                                ACC.datatables.savingStatus = false;
                            }

                            console.log("liste fin : ", ACC.datatables.tableRef);
                            console.log("liste tableRefUpdated : ", ACC.datatables.tableRefUpdated);

                        })
                            .on('keypress', '.edit-ref-input.mobile', function (e) {
                                if (e.which == 13) {
                                    $(this).blur();
                                }
                            });

                        function _showError(parent, input, type) {
                            parent.addClass('errors').find('.ref-errors').removeClass('hidden').find('.ref-error.' + type).removeClass('hidden');
                            input.removeClass('hidden').addClass('error').focus();
                            parent.find('.js-btn-edit-ref-mobile').addClass('hidden');
                            $('.js-btn-edit-ref-mobile').addClass('disabled');
                            return false;
                        }

                        function _hideError(container, input) {
                            container.removeClass('errors').find('.ref-errors').addClass('hidden').find('.ref-error').addClass('hidden');
                            //container.find('.js-btn-edit-ref-mobile').addClass('hidden');

                            input.removeClass('hidden');
                            $('.js-btn-edit-ref-mobile').removeClass('disabled');
                        }

                    }

                },
                complete: function () {
                    setTimeout(function () {
                        $("#mobileCustomerCatalog .js-check-mobile").change(function () {
                            var Icheck = $(this);
                            var idrefchecked = $(this).parents("tr").find(".idRefMobile").text();
                            var refName = $(this).parents("tr").find(".editContainerMobile .pk-text").text();
                            var objectChecked = {
                                id: idrefchecked,
                                name: refName
                            }
                            if (Icheck.is(':checked')) {
                                ACC.datatables.tableChecked.push(objectChecked);
                            } else {
                                for (var i = ACC.datatables.tableChecked.length - 1; i >= 0; i--) {
                                    var obj = ACC.datatables.tableChecked[i];
                                    if (idrefchecked.indexOf(obj.id) > -1) {
                                        ACC.datatables.tableChecked.splice(i, 1);
                                    }
                                }
                            }
                        });
                    }, 500);
                }
            })
                .fail(function (jqXHR, ajaxOptions, thrownError) {
                    alert('Something went wrong.');
                });
        }
    },
    triggerUpload: function () {
        $(".js-upload-catalogue").click(function (e) {
            e.preventDefault();
            if ($(window).width() < 640) {
                ACC.customercatalog.uploadCatalogueMobile();
            } else {
                ACC.customercatalog.uploadCatalogue();
            }
        });

        $(".w-upload-catalogue .upload-submit").on("click", function (e) {
            e.preventDefault();
            ACC.customercatalog.uploadForm();
        });
    },
    uploadCatalogue: function () {
        ACC.colorbox.open("", {
            href: "#uploadCustomerCatalog",
            inline: true,
            width: "500px",
            height: "430px",
            className: "popup-upload-catalogue",
            onComplete: function () {
                ACC.customercatalog.changeForm();
            },
            onClosed: function () {
                var $fileInput = $('.w-upload-catalogue .file-input');
                $fileInput.val("");
                $(".w-upload-catalogue .file-drop-area").load(location.href + " .w-upload-catalogue .file-drop-area-content");
                $(".w-upload-catalogue .progress").hide();
                $('.w-upload-catalogue .percent-text').text("");
                $(".w-upload-catalogue .wrapper-errors").load(location.href + " .w-upload-catalogue .wrapper-errors");
                $(".w-upload-catalogue .upload-submit").addClass("hidden");
            }
        });
    },
    uploadCatalogueMobile: function () {
        var $fileInput = $('.w-upload-catalogue .file-input');

        $('.w-upload-catalogue .file-input').click();
        // change inner text
        $fileInput.on('change', function () {
            $('.w-upload-catalogue .wrapper-errors').addClass("hidden");
            $('.w-upload-catalogue .wrapper-drop').removeClass("hidden");
            $('.w-upload-catalogue .textError').removeClass("visible");
            $('.w-upload-catalogue').removeClass("height-sm").removeClass("clean-popup");

            var $fileval = $fileInput.val();
            var filesCount = $(this)[0].files.length;
            var $textContainer = $(this).prev();
            var maxSizeMb = 1;

            if (filesCount == 1) {
                // if single file is selected, show file name
                // Allowing file type
                var fileSelected = $(this)[0].files[0];
                var allowedExtensions = /(\.csv|\.xls|\.xlsx)$/i;
                //Get the size of the input file.
                var totalSize = fileSelected.size;

                //Convert bytes into MB.
                var totalSizeMb = totalSize / Math.pow(1024, 2);
                if (!allowedExtensions.exec($fileval)) {
                    $('.w-upload-catalogue .wrapper-errors').removeClass("hidden");
                    $('.w-upload-catalogue .textError').removeClass("visible");
                    $('.w-upload-catalogue .format-error').addClass("visible");
                    $fileInput.val("");
                    $('.w-upload-catalogue .wrapper-drop').addClass("hidden");
                    $('.w-upload-catalogue').addClass("height-sm");

                    ACC.colorbox.open("", {
                        href: "#uploadCustomerCatalog",
                        inline: true,
                        width: "500px",
                        height: "400px",
                        className: "popup-upload-catalogue",
                        onComplete: function () {
                            $.colorbox.resize();
                        },
                        onClosed: function () {
                            $(".w-upload-catalogue .file-drop-area").load(location.href + " .w-upload-catalogue .file-drop-area-content");
                        }
                    });
                    return false;
                } else if (totalSizeMb > maxSizeMb) {
                    //Create an error message to show to the user.
                    // var errorMsg = 'File too large. Maximum file size is ' + maxSizeMb + 'MB. Selected file is ' + totalSizeMb.toFixed(2) + 'MB';
                    $fileInput.val("");
                    //Show the error.
                    $('.w-upload-catalogue .wrapper-errors').removeClass("hidden");
                    $('.w-upload-catalogue .textError').removeClass("visible");
                    $('.w-upload-catalogue .size-error').addClass("visible");
                    $('.w-upload-catalogue .wrapper-drop').addClass("hidden");
                    $('.w-upload-catalogue').addClass("height-sm");
                    ACC.colorbox.open("", {
                        href: "#uploadCustomerCatalog",
                        inline: true,
                        width: "500px",
                        height: "400px",
                        className: "popup-upload-catalogue",
                        onComplete: function () {
                        },
                        onClosed: function () {
                            $(".w-upload-catalogue .file-drop-area").load(location.href + " .w-upload-catalogue .file-drop-area-content");
                        }
                    });
                } else {
                    $('.w-upload-catalogue .wrapper-errors').addClass("hidden");
                    $('.w-upload-catalogue .textError').removeClass("visible");
                    $('.w-upload-catalogue .wrapper-drop').addClass("hidden");
                    $('.w-upload-catalogue').removeClass("height-sm").addClass("clean-popup");
                    ACC.colorbox.open("", {
                        href: "#uploadCustomerCatalog",
                        inline: true,
                        width: "500px",
                        height: "100px",
                        closeButton: false,
                        escKey: false,
                        overlayClose: false,
                        className: "popup-upload-catalogue single-loading",
                        onComplete: function () {
                        },
                        onClosed: function () {
                            $(".w-upload-catalogue .file-drop-area").load(location.href + " .w-upload-catalogue .file-drop-area-content");
                        }
                    });
                    var fileName = $(this).val().split('\\').pop();
                    $textContainer.text(fileName);
                    ACC.customercatalog.triggerProgress();
                }
            }
        });
    },
    changeForm: function () {

        var $fileInput = $('.w-upload-catalogue .file-input');
        var $droparea = $('.w-upload-catalogue .file-drop-area');

        // highlight drag area
        $fileInput.on('dragenter focus click', function () {
            $droparea.addClass('is-active');
        });

        // back to normal state
        $fileInput.on('dragleave blur drop', function () {
            $droparea.removeClass('is-active');
        });
        // change inner text
        $fileInput.on('change', function () {
            $('.w-upload-catalogue .wrapper-errors').addClass("hidden");
            $('.w-upload-catalogue .file-drop-area').removeClass("hidden");
            $('.w-upload-catalogue .textError').removeClass("visible");
            var $fileval = $fileInput.val();
            var filesCount = $(this)[0].files.length;
            var $textContainer = $(this).prev();
            var maxSizeMb = 1;
            var allowedExtensions = /(\.csv|\.xls|\.xlsx)$/i;

            //check selected file type
            if (!allowedExtensions.exec($(this)[0].files[0])) {
                $('.w-upload-catalogue .wrapper-errors').removeClass("hidden");
                $('.w-upload-catalogue .textError').removeClass("visible");
                $('.w-upload-catalogue .format-error').addClass("visible");

                $.colorbox.resize();
            }

            if (filesCount == 1) {
                // if single file is selected, show file name
                // Allowing file type
                var fileSelected = $(this)[0].files[0];
                var allowedExtensions = /(\.csv|\.xls|\.xlsx)$/i;
                //Get the size of the input file.
                var totalSize = fileSelected.size;

                //Convert bytes into MB.
                var totalSizeMb = totalSize / Math.pow(1024, 2);
                if (!allowedExtensions.exec($fileval)) {
                    $('.w-upload-catalogue .wrapper-errors').removeClass("hidden");
                    $('.w-upload-catalogue .textError').removeClass("visible");
                    $('.w-upload-catalogue .format-error').addClass("visible");
                    $fileInput.val("");
                    return false;
                } else if (totalSizeMb > maxSizeMb) {
                    //Create an error message to show to the user.
                    // var errorMsg = 'File too large. Maximum file size is ' + maxSizeMb + 'MB. Selected file is ' + totalSizeMb.toFixed(2) + 'MB';
                    $fileInput.val("");
                    //Show the error.
                    $('.w-upload-catalogue .wrapper-errors').removeClass("hidden");
                    $('.w-upload-catalogue .textError').removeClass("visible");
                    $('.w-upload-catalogue .size-error').addClass("visible");
                } else {
                    $('.w-upload-catalogue .wrapper-errors').addClass("hidden");
                    $('.w-upload-catalogue .textError').removeClass("visible");
                    $.colorbox.resize({height: "450px"});
                    var fileName = $(this).val().split('\\').pop();
                    $textContainer.text(fileName);
                    ACC.customercatalog.triggerProgress();

                }
            }
        });
    },
    triggerProgress: function () {
        var selectedFile = document.getElementsByName('csvFileCatalogue')[0].files[0];
        var form = document.getElementById('importCSVSavedCartForm');
        var formData = new window.FormData(form);
        formData.append("csvFile", selectedFile);
        var urlActionValidate = $('.form-upload-file-catalogue').attr('data-validate');

        $.ajax({
            type: "POST",
            url: urlActionValidate,
            data: formData,
            processData: false,
            contentType: false,
            success: function (file) {
                console.log("SUCCESS : progress");

                if ($(window).width() < 640) {
                    setTimeout(function () {
                        $(".w-upload-catalogue .upload-submit").click();
                    }, 2000);
                } else {
                    setTimeout(function () {
                        // $(".progress").hide();
                        $(".w-upload-catalogue .upload-submit").removeClass("hidden");
                    }, 1500);
                }
            },
            error: function (e) {
                console.log("ERROR : ", e);
            },
            xhr: function () {
                var fileXhr = $.ajaxSettings.xhr();
                if (fileXhr.upload) {
                    $(".progress").show();
                    fileXhr.upload.addEventListener("progress", function (e) {
                        if (e.lengthComputable) {
                            var percentage = Math.ceil(((e.loaded / e.total) * 100));
                            var textEnding = $('.end-of-progress').text();
                            $('.percent-text').text(percentage + '% loading');
                            $('.progress-bar .loading-animate').css("width", percentage + '%');
                            if (percentage == 100) {
                                $('.percent-text').text(textEnding);
                            }
                        }
                    }, false);
                }
                return fileXhr;
            }
        });
    },
    uploadForm: function () {
        var selectedFile = document.getElementsByName('csvFileCatalogue')[0].files[0];
        var form = $('.form-upload-file-catalogue')[0];
        var formData = new window.FormData(form);
        formData.append("csvFile", selectedFile);
        var urlAction = $('.form-upload-file-catalogue').attr('action');
        var _customerCatalogProducts = JSON.parse(localStorage.getItem('_customerCatalogProducts')) || [],
            _uploadModal = $('.popup-upload'),
            _waitingMessageModal = this.loaderModalWithMessage(ACC.configUploadWaitingMessage);

        $('#wait-place-holder').html(_waitingMessageModal);

        $.ajax({
            type: "POST",
            url: urlAction,
            data: formData,
            processData: false,
            contentType: false,
            beforeSend: function(){
                $('#wait-place-holder').show();
                $('.popup-upload-catalogue').hide()
            },
            success: function (file) {

                if (file.data) {
                    console.log('DATA UP')
                    ACC.datatables.savingStatus = false;
                    $.each(file.data, function (index, val) {
                        ACC.datatables.tableRefUpdated.push({
                            productCode: val.articleRef,
                            productName: val.productName,
                            productReference: val.reference
                        });
                    });
                    $.each(ACC.datatables.tableRefInitPaged, function (key1, value1) {
                        $.each(file.data, function (key2, value2) {

                            if (value1[2] == value2.articleRef) {
                                if ($(window).width() < 640) {
                                    $("#mobileCustomerCatalog tr").each(function (e, item) {
                                        var $this = $(this);
                                        if ($this.find(".idRefMobile").text() == value2.articleRef) {
                                            $this.find(".editTextMobile .edit-ref-input").val(value2.reference.trim());
                                        }
                                    });
                                } else {
                                    $("#customerCatalog tr").each(function (e, item) {
                                        var $this = $(this);
                                        if ($this.find(".idRef").text() == value2.articleRef) {
                                            $this.find(".editText .ref-text").text(value2.reference.trim());
                                        }
                                    });
                                }
                            }
                        });
                    });

                    //Add a new line
                    const frontDiffs = file.data.filter(({articleRef}) =>
                        !_customerCatalogProducts.some(({_articleRef}) => _articleRef === articleRef)
                    );

                    frontDiffs.map(line => $('#customerCatalog').append(ACC.customercatalog.createNewLine(line)));
                    ACC.datatables.tableResponseRefs = file.data;
                    $(".status-saving .color-status").removeClass("green");
                    $(".status-saving .text-status").addClass("hidden");
                    $(".status-saving .text-status.not-saving").removeClass("hidden");
                    $('#customerCatalog').DataTable().ajax.reload();

                    ACC.colorbox.close();
                    $('#wait-place-holder').hide();
                }
                $('#wait-place-holder').hide();
            },
            error: function (e) {
                console.log(e)
                _uploadModal.show();
                $('.popup-upload-catalogue').show();
                $('#wait-place-holder').hide();

                $(".w-upload-catalogue .upload-submit").addClass("hidden");
                var $fileInput = $('.w-upload-catalogue .file-input');
                if (e.responseJSON.errors) {
                    if ($(window).width() < 640) {
                        //Show the error.
                        $fileInput.val("");
                        $(".w-upload-catalogue .file-drop-area").load(location.href + " .w-upload-catalogue .file-drop-area-content");
                        // hide all errors
                        $('.w-upload-catalogue .textError.newOne').remove();
                        //Show the error.
                        $.each(e.responseJSON.errors, function (i, f) {
                            $('#uploadCustomerCatalog .list-errors').append("<li class='textError newOne'>- " + f + "</li>");
                        });
                        $('.w-upload-catalogue .wrapper-errors').removeClass("hidden");
                        $('.w-upload-catalogue .list-errors').removeClass("hidden");
                        $('.w-upload-catalogue .textError').addClass("visible");
                        $('.w-upload-catalogue .format-error').removeClass("visible");
                        $('.w-upload-catalogue .size-error').removeClass("visible");
                        $('.w-upload-catalogue').addClass("height-sm");
                        ACC.colorbox.open("", {
                            href: "#uploadCustomerCatalog",
                            inline: true,
                            width: "500px",
                            height: "400px",
                            className: "popup-upload-errors",
                            onComplete: function () {
                            },
                            onClosed: function () {
                                window.location.reload();
                            }
                        });
                    } else {
                        $(".w-upload-catalogue .file-msg").load(location.href + " .w-upload-catalogue .file-msg");
                        $fileInput.val("");
                        $(".w-upload-catalogue .progress").hide();
                        $('.w-upload-catalogue .percent-text').text("");
                        // hide all errors
                        $('.w-upload-catalogue .textError.newOne').remove();
                        //Show the error.
                        $.each(e.responseJSON.errors, function (i, f) {
                            $('.w-upload-catalogue .list-errors').append("<li class='textError newOne'>- " + f + "</li>");
                        });
                        $('.w-upload-catalogue .wrapper-errors').removeClass("hidden");
                        $('.w-upload-catalogue .list-errors').removeClass("hidden");
                        $('.w-upload-catalogue .textError').addClass("visible");
                        $('.w-upload-catalogue .format-error').removeClass("visible");
                        $('.w-upload-catalogue .size-error').removeClass("visible");
                    }
                }

            }
        });
    },
    createNewLine: function (line) {
        console.log(line)
        var errorTextMax = $(".js-error-max-char").text();
        var errorTextUnique = $(".js-error-unique-ref").text();
        var newLine = `<tr>
                                <td class="paddingScale">
                                <div class="form-checkbox"><input class="check js-checkbox-ref" type="checkbox" name="check" /> <label for="checkboxRef" tabindex="1"></label></div>
                            </td>
                            <td class="firstCol sorting_1"></td>
                                <td class="idRef">${line.articleRef}</td>
                                <td class="paddingScale">${line.articleTitle}</td>
                            <td class="editText sorting_2">
                                <div class="editContainer">
                                <div class="ref-text" data-old=""></div>
                                <input type="text" class="edit-ref-input mobile hidden" name="editRef" />
                                <div class="pk-text hidden"></div>
                                <div class="ref-errors hidden">
                                <span class='max-char-error ref-error hidden'>${errorTextMax}</span>
                                <span class='unique-error ref-error hidden'>${errorTextUnique}</span>
                                </div>
                            </div>
                            <div class="icon-edit js-btn-edit-ref"></div>
                                </td>
                        </tr>`
        return newLine;
    },
    triggerDownload: function () {

        $(".js-download-link-mobile").click(function (e) {
            e.preventDefault();
            var arrayRefDown = "";
            var valRefDown = "", i = 0;
            $.each(ACC.datatables.tableChecked, function (index, val) {
                i += 1;
                valRefDown = val.name;
                if (i == 1) {
                    arrayRefDown += valRefDown;
                } else {
                    arrayRefDown += "," + valRefDown;
                }

            });

            if (ACC.datatables.tableRef.length > 0 && ACC.datatables.savingStatus == false) {


                ACC.colorbox.open("", {
                    href: "#w-leave-page",
                    inline: true,
                    width: "560px",
                    height: "340px",
                    className: "popup-leave",
                    onComplete: function () {
                        $(".js-refuse-save").click(function (e) {
                            e.preventDefault();
                            ACC.colorbox.close();
                        });

                        $(".js-accept-save").click(function (e) {
                            e.preventDefault();
                            $(".js-save-btn").trigger("click");
                            ACC.colorbox.close();
                        })
                    },
                    onClosed: function () {
                    }
                });
            } else {
                if (arrayRefDown != "") {
                    window.location = ACC.config.encodedContextPath + "/my-account/customer-catalog/export?references=" + arrayRefDown;
                } else {
                    var i = 0;
                    $("#mobileCustomerCatalog tbody tr").each(function (e, item) {
                        var $this = $(this);
                        i += 1;
                        valRefDown = $this.find(".editContainerMobile .pk-text").text();
                        if (i == 1) {
                            arrayRefDown += valRefDown;
                        } else {
                            arrayRefDown += "," + valRefDown;
                        }
                    });
                    window.location = ACC.config.encodedContextPath + "/my-account/customer-catalog/export?references=" + arrayRefDown;
                }
            }


        });
    },
    loaderModalWithMessage: function (msg) {
        return `<div class="wait-place-order"> ${msg}<div class="loader"></div></div>`;
    }
}
